export const GLOBAL_INTERCOM = 'GLOBAL/INTERCOM';
export const GLOBAL_LOGIN = 'GLOBAL/LOGIN';
export const GLOBAL_LOGOUT = 'GLOBAL/LOGOUT';
export const CHECKOUT_ORDER_APPROVED = 'CHECKOUT/ORDER_APPROVED';
export const CHECKOUT_ORDER_SUMMARY = 'CHECKOUT/ORDER_SUMMARY';
export const CHECKOUT_PAYMENT_TYPE = 'CHECKOUT/PAYMENT_TYPE';
export const CHECKOUT_PAYMENT_SUMMARY = 'CHECKOUT/PAYMENT_SUMMARY';
export const CHECKOUT_PAYMENT_DELIVERY_PREFS = 'CHECKOUT/PAYMENT_DELIVERY_PREFS';
export const CHECKOUT_NEW_CARD = 'CHECKOUT/NEW_CARD';
export const CHECKOUT_EXISTING_CARD = 'CHECKOUT/EXISTING_CARD';
export const CHECKOUT_EXEMPTION_REASON = 'CHECKOUT/EXEMPTION_REASON';
export const CHECKOUT_EXEMPTION_EVIDENCE = 'CHECKOUT/EXEMPTION_EVIDENCE';
export const CHECKOUT_CONFIRM_EXEMPTION_STATUS =
  'CHECKOUT/CONFIRM_EXEMPTION_STATUS';
export const CHECKOUT_CONFIRM_EXEMPTION_REASON =
  'CHECKOUT/CONFIRM_EXEMPTION_REASON';
export const CHECKOUT_CONFIRM_EXEMPTION_EVIDENCE =
  'CHECKOUT/CONFIRM_EXEMPTION_EVIDENCE';
export const CHECKOUT_UPLOAD_EVIDENCE = 'CHECKOUT/UPLOAD_EVIDENCE';
export const CHECKOUT_SKIP_EVIDENCE = 'CHECKOUT/SKIP_EVIDENCE';
export const CHECKOUT_DECLARE_EXEMPTION = 'CHECKOUT/DECLARE_EXEMPTION';
export const CHECKOUT_COMPLETE = 'CHECKOUT/COMPLETE';

export const CHECKOUT_CLICK_AND_COLLECT = 'CHECKOUT/CHECKOUT_CLICK_AND_COLLECT';

export const ORDERING_DELIVERY_TIME = 'ORDERING/DELIVERY_TIME';
export const ORDERING_DUE_DATE = 'ORDERING/DUE_DATE';
export const ORDERING_CHAT_WITH_US = 'ORDERING/CHAT_WITH_US';
export const ORDERING_SEARCH_MEDICINE = 'ORDERING/SEARCH_MEDICINE';
export const ORDERING_SELECT_FROM = 'ORDERING/SELECT_FROM';
export const ORDERING_SELECT_PRODUCT = 'ORDERING/SELECT_PRODUCT';
export const ORDERING_BASKET = 'ORDERING/BASKET';
export const ORDERING_BARCODE = 'ORDERING/BARCODE';
export const ORDERING_SUMMARY = 'ORDERING/SUMMARY';
export const ORDERING_CHANGE_DELIVERY_ADDRESS =
  'ORDERING/CHANGE_DELIVERY_ADDRESS';

export const ORDERING_CHANGE_DELIVERY_PREFERENCE = 'ORDERING/ORDERING_CHANGE_DELIVERY_PREFERENCE';

export const ORDERING_COMPLETE = 'ORDERING/COMPLETE';
export const ORDERING_REORDER = 'ORDERING/REORDER';
export const ORDERING_SELECT_MEDICINE_FORM = 'ORDERING/SELECT_MEDICINE_FORM';
export const ORDERING_SELECT_MEDICINE_STRENGTH = 'ORDERING/SELECT_MEDICINE_STRENGTH';
export const SIGNUP_EMAIL = 'SIGNUP/EMAIL';
export const SIGNUP_EMAIL_SENT = 'SIGNUP/EMAIL_SENT';
export const SIGNUP_EMAIL_RESEND = 'SIGNUP/EMAIL_RESEND';
export const SIGNUP_EMAIL_ISSUES = 'SIGNUP/EMAIL_ISSUES';
export const SIGNUP_NAME = 'SIGNUP/NAME';
export const SIGNUP_DETAILS = 'SIGNUP/DETAILS';
export const SIGNUP_ADDRESS = 'SIGNUP/ADDRESS';
export const SIGNUP_GP = 'SIGNUP/GP';
export const SIGNUP_MEDICINE = 'SIGNUP/MEDICINE';
export const SIGNUP_WAITING = 'SIGNUP/WAITING';
export const SIGNUP_SHARE_LINK = 'SIGNUP/SHARE_LINK';
export const SIGNUP_READY = 'SIGNUP/READY';
export const SIGNUP_CONSENT = 'SIGNUP/CONSENT';
export const SIGNUP_COMPLETE = 'SIGNUP/COMPLETE';
